<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span @click="cur=1;jumpToArrange()" :class="{active_table:cur=1}">作业安排</span>
        </div>
        <div class="head_title_font class_head_title_font" style="margin-left: 20px">
          <span @click="cur=0;jumpToScore()" :class="{active_table:cur=0}">作业成绩</span>
        </div>
      </div>
      <div class="body_content class_body_content">
        <div v-if="publishStatus == 0" class="ifDiv">
          <div class="homework_left_div" >
            <!-- <button type="button" class="btn btn-default homework_type_add">+新增作业类别</button>-->
            <ul id="myTab" class="nav nav-tabs">
              <li class="homework_one liClass" v-for="(schoolWorkOne,index) in schoolWorkList_" :key="index" :class="{active: current_index == index}" @click="current_index=index;initSchoolWorkList()">
                <a :href="schoolWorkOne.name" data-toggle="tab">
                  {{schoolWorkOne.type}}
                </a>
              </li>
            </ul>
            <!--新增作业类别-->
            <!-- <div class="homework_type_add">
               <input type="text" placeholder="输入新增类别名称">
               <button type="button" class="btn-default">确定</button>
               <button type="button" class="btn-default">取消</button>
             </div>-->
          </div>
          <div class="homework_right_div">
            <div id="myTabContent" class="tab-content">
              <div class="tab-pane fade in active" :id="schoolWorkList_[current_index].id">
                <button type="button" class="btn btn-default btn_option homework_add " data-toggle="modal" data-target="#myModal" @click="homeworkOption='add'">+新增作业</button>
                <div>
                  <table class="table table-striped table-bordered homework_table">
                    <thead>
                    <tr>
                      <th width="22%">作业名称</th>
                      <th width="24%">作业要求</th>
                      <th width="22%">提交截止时间</th>
                      <th width="22%">附件</th>
                      <th width="10%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(schoolWork,index) in schoolWorkList" :key="index">
                      <td width="22%">{{schoolWork.name}}</td>
                      <td width="24%">{{schoolWork.summary}}</td>
                      <td width="22%">{{schoolWork.deadline}}</td>
                      <td width="22%">
                        <a @click="openPreviewModal(schoolWork.fileName, schoolWork.filePath)">{{schoolWork.fileName}}</a><br>
                      </td>
                      <td width="10%">
                        <div class="homework_edit" @click="editHomeworkId=schoolWork.schoolworkId;homeworkOption='update';getSchoolWorkById()"></div>
                        <div class="homework_delete" @click="editHomeworkId=schoolWork.schoolworkId;deleteSchoolWorkById()"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <!--<button type="button" class="btn btn-default btn_option homework_add " data-toggle="modal" data-target="#myModal" @click="homeworkOption='add'">+新增作业</button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="publishStatus == 1 && classStatus == 0" class="ifDiv">
          <div class="homework_left_div" >
            <ul id="myTab_two" class="nav nav-tabs">
              <li class="homework_one liClass" v-for="(schoolWorkOne,index) in schoolWorkList_" :key="index" :class="{active: current_index == index}" @click="current_index=index;initSchoolWorkList()">
                <a :href="schoolWorkOne.name" data-toggle="tab">
                  {{schoolWorkOne.type}}
                </a>
              </li>
            </ul>
          </div>
          <div class="homework_right_div">
            <div id="myTabContent_two" class="tab-content">
              <div class="tab-pane fade in active" :id="schoolWorkList_[current_index].id">
                <button type="button" class="btn btn-default btn_option homework_add " data-toggle="modal" data-target="#myModal" @click="homeworkOption='add'">+新增作业</button>
                <div>
                  <table class="table table-striped table-bordered homework_table">
                    <thead>
                    <tr>
                      <th width="22%">作业名称</th>
                      <th width="24%">作业要求</th>
                      <th width="22%">提交截止时间</th>
                      <th width="22%">附件</th>
                      <th width="10%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(schoolWork,index) in schoolWorkList" :key="index">
                      <td  width="22%">{{schoolWork.name}}</td>
                      <td  width="24%">{{schoolWork.summary}}</td>
                      <td  width="22%">{{schoolWork.deadline}}</td>
                      <td  width="22%">
                        <a @click="openPreviewModal(schoolWork.fileName, schoolWork.filePath)">{{schoolWork.fileName}}</a><br>
                      </td>
                      <td width="10%">
                        <div class="homework_edit_two" @click="editHomeworkId=schoolWork.schoolworkId;homeworkOption='update';getSchoolWorkById()"></div>
                        <!--<div class="homework_edit_two" @click="editHomeworkId=schoolWork.schoolworkId;homeworkOption='update';getSchoolWorkById()"></div>-->
                        <div class="homework_delete" @click="editHomeworkId=schoolWork.schoolworkId;deleteSchoolWorkById()"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <!--<button type="button" class="btn btn-default btn_option homework_add " data-toggle="modal" data-target="#myModal" @click="homeworkOption='add'">+新增作业</button>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--新增作业-->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  {{homeworkOption=="add"?'新增作业':'修改作业'}}
                </h4>
              </div>
              <div class="modal-body">
                <form role="form" class="homeworkArrange_form">
                  <input v-validate="'required|maxL:80'" data-vv-scope="homework" data-vv-as="作业名称" name="homeworkName" class="form-control" type="text" placeholder="输入作业名称" v-model="schoolWorkInfo.name">
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('homework.homeworkName') }}</span>

                  <textarea v-validate="'required|maxL:300'" data-vv-scope="homework" data-vv-as="作业要求" name="homeworkSummary" class="form-control homeSummary" rows="" placeholder="输入作业要求" v-model="schoolWorkInfo.summary"></textarea>
                  <span class="spanRed homeSummary">*</span>
                  <span class="validateTip">{{ errors.first('homework.homeworkSummary') }}</span>

                  <input v-validate="'required'" data-vv-scope="homework" data-vv-as="提交作业截止时间" class="form-control" type="text" size="16" name="chooseDeadline" id="chooseDeadline" placeholder="选择提交截止时间" v-model="schoolWorkInfo.deadline" autocomplete="off">
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('homework.chooseDeadline') }}</span>
                </form>

                <div class="editVideoDiv" v-if="(homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)">
                  <label>历史上传附件：</label>
                  <p class="fileListP">
                    <a @click="openVideoModal(schoolWorkInfo.filePath)">{{schoolWorkInfo.fileName}}</a>
                    <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(schoolWorkInfo.attachmentId)"></span>
                  </p>
                </div>

                <uploader v-bind:class="{displayVideoUploadCom: (homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)}"
                          :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽文件至此处</p>
                    <uploader-btn :attrs="upload.attrs.video">选择视频</uploader-btn>
                    <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
                    <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default btn_save" v-on:click="modalClickOk()">
                  确认
                </button>
                <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--图片显示-->
        <div class="modal fade" id="myModal_showAllImages" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showAllImages" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog_preview">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showAllImages">
                  图片预览
                </h4>
              </div>
              <div class="modal-body modal-body_preview">
                <img :src="imageSrc" class="previewImg"/>
              </div>
            </div>
          </div>
        </div>

        <!--视频显示-->
        <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog_preview">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showVideo">
                  视频预览
                </h4>
              </div>
              <div class="modal-body modal-body_preview">
                <video class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                </video>
              </div>
            </div>
          </div>
        </div>

        <!--文档显示-->
        <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog_preview">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showFile">
                  文档预览
                </h4>
              </div>
              <div class="modal-body modal-body_preview">
                <iframe :src="fileSrc" width="100%" height="700px"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';

  export default {
    name: "homeworkArrange",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        schoolWorkList: [],
        current_index: 0,
        schoolWorkList_: [
          {name: '#one', id:'one', type: '党性修养考核'},
          {name: '#two', id:'two', type: '知识能力考核'},
          {name: '#three', id:'three', type: '调研课题'},
          {name: '#four', id:'four', type: '结业论文'},
        ],

        homeworkOption: '',

        editHomeworkId: '',

        isUploadFile: false,
        isDeleteFile: false,

        //今日日期
        timeDate: '',

        schoolWorkInfo: {
          id:'',
          name: '',
          summary: '',
          deadline: '',
          createTime: '',
          fileName: '',
          filePath: '',
          attachmentId: '',
        },

        //上传
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            /*query: {
              attachmentType: 'zy'
            },*/
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 1024*1024,
            singleFile: true
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            image: {
              accept: 'image/*'
            },
            video: {
              accept: 'video/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },

        //图片
        imageSrc: '',

        //视频
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',

        //文档
        fileSrc: '',
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.closeModal();

        //日期
        this_.dateDefault();
        this_.initSchoolWorkList();

        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();
      });
    },
    methods: {
      /**
       * 加载作业列表
       */
      initSchoolWorkList(){
        let this_=this;

        schoolAxios({
          method: 'get',
          url: 'schoolwork/findSchoolHomeworkList',
          params:{
            "clazzId":this_.clazzId,
            "type": this_.schoolWorkList_[this_.current_index].type
          }
        }).then(function (response) {
          // console.info(response);
          let data = response.data;
          if(data.success){
            this_.schoolWorkList = data.list;
          }
        });
      },

      modalClickOk(){
        let this_ = this;
        if(this_.homeworkOption == 'add'){
          this_.addSchoolWork();
        }else {
          this_.updateSchoolWorkContent();
        }
      },

      addSchoolWork(){
        let this_=this;
        //if(this_.validateDataIsEmpty) {
        this_.$validator.validateAll('homework').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'schoolwork/add',
              data: {
                'id': this_.schoolWorkInfo.id,
                'name': this_.schoolWorkInfo.name,
                'summary': this_.schoolWorkInfo.summary,
                'deadline': this_.schoolWorkInfo.deadline,
                "clazzId": this_.clazzId,
                "type": this_.schoolWorkList_[this_.current_index].type,
                "attachmentIds": this_.schoolWorkInfo.attachmentId
              }
            }).then(function (response) {
              // console.info(response);
              let data = response.data;
              if (data.success) {
                $("#myModal").modal("hide");
                "添加成功".showMessage();
                this_.initSchoolWorkList();
              } else {
                //"添加失败".showMessage();
                data.message.showMessage();
              }
            })
          }
        });
      },
      /* validateDataIsEmpty(){
         let this_ = this;
         if(this_.schoolWorkInfo.name== ""){
           "请输入作业名称".showMessage();
           return false;
         }
         if(this_.schoolWorkInfo.summary== ""){
           "请输入作业要求".showMessage();
           return false;
         }
         if(this_.schoolWorkInfo.deadline== ""){
           "请选择提交截止时间".showMessage();
           return false;
         }
         return true;
       },*/
      getSchoolWorkById(){
        let this_=this;
        schoolAxios({
          method:'get',
          url: 'schoolwork/load/'+this_.editHomeworkId,
          params:{}
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.schoolWorkInfo.id=data.data.id;
            this_.schoolWorkInfo.name=data.data.name;
            this_.schoolWorkInfo.summary=data.data.summary;
            this_.schoolWorkInfo.deadline=data.data.deadline;
            this_.schoolWorkInfo.fileName=data.data.fileName;
            this_.schoolWorkInfo.filePath=data.data.filePath;
            this_.schoolWorkInfo.attachmentId=data.data.attachmentId;
            //console.info(data.data.attachmentId,data.data.attachmentId && data.data.attachmentId!="");
            if(data.data.attachmentId && data.data.attachmentId!=""){
              this_.isUploadFile = true;
              this_.isDeleteFile = false;
            }else{
              this_.isUploadFile = false;
              this_.isDeleteFile = false;
            }
            $("#myModal").modal("show");
          }
        });
      },
      deleteAttachmentsFile(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.isUploadFile = false;
              this_.isDeleteFile = true;
              this_.upload.uploader.cancel();
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },
      updateSchoolWorkContent(){
        let this_=this;
        this_.$validator.validateAll('homework').then(result => {
          if (result) {
            schoolAxios({
              method: 'put',
              url: 'schoolwork/edit',
              data: {
                'id': this_.schoolWorkInfo.id,
                'name': this_.schoolWorkInfo.name,
                'summary': this_.schoolWorkInfo.summary,
                'deadline': this_.schoolWorkInfo.deadline,
                "clazzId": this_.clazzId,
                "type": this_.schoolWorkList_[this_.current_index].type,
                "attachmentIds": this_.schoolWorkInfo.attachmentId
              }
            }).then(function (response) {
              // console.info(response);
              let data = response.data;
              if (data.success) {
                $("#myModal").modal("hide");
                "修改成功".showMessage();
                this_.initSchoolWorkList();
              } else {
                "修改失败".showMessage();
              }
            })
          }
        });
      },
      deleteSchoolWorkById(){
        let this_=this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'schoolwork/delete/' + this_.editHomeworkId,
            params: {}
          }).then(function (response) {
            this_.initSchoolWorkList();
          });
        })
      },

      /**
       * 打开预览模态框
       */
      openPreviewModal(fileName, filePath) {
        let this_ = this;

        let suffix = fileName.substring(fileName.lastIndexOf('.')+1);

        if("mp4".indexOf(suffix)!=-1){
          this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showVideo").modal("show");
        }else if("doc,docx,pdf".indexOf(suffix)!=-1) {
          let data = filePath.substring(0, 11);
          let fileId = filePath.substring(11, filePath.indexOf('.'));
          this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
          $("#myModal_showFile").modal("show");
        }else {
          this_.imageSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showAllImages").modal("show");
        }
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal').on('hide.bs.modal', function () {
          this_.schoolWorkInfo = {
            id:'',
            name: '',
            summary: '',
            deadline: '',
            createTime: '',
            fileName: '',
            filePath: '',
            attachmentId: '',
          };
          this_.isUploadFile = false;
          this_.isDeleteFile = false;
          this_.upload.uploader.cancel();

          setTimeout(function () {
            this_.errors.clear('homework');
          });

        });

        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc = "";
        });


      },

      /**
       * 取消保存作业
       */
      cancelSaveHomeWork(){
        let this_ = this;
      },

      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          /*if(this_.schoolWorkInfo.attachmentId != ""){
            "只允许上传一次附件".showMessage();
            return false;
          }*/
          if(file.fileType.indexOf("video")==-1 && file.fileType.indexOf("image")==-1 && this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);

            //目前只允许提交一个附件，所以附件ID为空
            this_.schoolWorkInfo.attachmentId = "";

            if(this_.schoolWorkInfo.attachmentId != ""){
              this_.schoolWorkInfo.attachmentId += ",";
            }
            this_.schoolWorkInfo.attachmentId += message_.message;
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
      /**
       * 作业安排作业成绩tab切换
       */
      jumpToArrange(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'HomeworkArrange',
        });
      },
      jumpToScore(){
        let this_ = this;
        this_.$router.push({
          name: 'HomeworkScore',
        });
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseDeadline').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseDeadline").val();
          this_.schoolWorkInfo.deadline = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .class_head_title_font {
    width: 80px;
    cursor: pointer;
  }
  .head_title_font {
    border: none;
  }
  .active_table {
    /*background-color: #ff6f66;*/
    color: #ff6f66;
    padding-bottom: 8px;
    border-bottom: 3px solid #ff6f66;
  }
  .table {
    table-layout: fixed;
    width: 100%;
    text-align: center;
  }
  .table-striped {
    background-color: #FFFFFF;
  }

  /*.table th {
    text-align: center;
    color: #FFFFFF;
    background-color: #666666;
  }*/
  .table th{
    height: 40px;
    text-align: center;
    color: black;
    background-color: #CCCCCC;
  }
  .table tr td,.table th{
    /*border: 1px solid #cccccc;*/
  }

  .table tr td {
    word-wrap: break-word;
    height: 40px;
  }
  .homework_table tbody {
    height: 440px;
  }
  @media (max-height: 768px) {
    .homework_table tbody {
      height: 300px;
    }
  }

  .ifDiv {
    height: 100%;
    width: 100%;
  }

  .homework_type_add {
    width: 160px;
    height: 40px;
    font-size: 15px;
    border-radius: 5px;
    /*margin: 20px 0 25px 0;*/
  }


  ul li {
    clear: left;
  }

  .tab-content {
    width: 100%;
    /* margin: 0 0 0 15%;*/
    /*background-color: #C9C9C9;*/
  }
  .tab-pane {
    padding: 22px 36px 0 36px;
  }
  .homework_add {
    height: 33px;
    width: 140px;
    border-radius: 5px;
    margin: 0 0 30px 0;
    font-size: 15px;
  }
  .homework_edit {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 10px 0 12px;
  }
  .homework_edit_two {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    /*background-image: url("../img/right/clazz/edit_disabled.png");*/
    background-size: 100% 100%;
    float: left;
    margin: 0 10px 0 12px;
  }
  .homework_edit:hover{
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    background-size: 100% 100%;
  }
  .homework_delete {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete.png");
    background-size: 100% 100%;
    float: left;
  }
  .homework_delete:hover{
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    background-size: 100% 100%;
  }
  .homework_left_div {
    position: absolute;
    left: 0;
    top: 4%;
    width: 14%;
    height: 92%;
  }
  .homework_right_div {
    position: absolute;
    left: 14%;
    top: 4%;
    width: 86%;
    height: 92%;
    /*background-color: #C9C9C9;*/
    border: 1px #ccc solid;
  }

  .liClass {
    margin: 15px 0px;
    width: 160px;
    height: 40px;
    font-size: 15px;
    border-radius: 5px;
  }
  .liClass a {
    color: black;
    cursor: default;
  }

  .nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover :after{
    color: #fff;
    cursor: default;
    background-color: #ff6f66;
    border: 0px;
    /*border-bottom: 2px black solid;*/
    border-radius: 5px;
  }
  /*.nav-tabs>li.active>a:focus:after{
   background-image: url("../img/right/homeworkArrange/homework_left_pic.png");
  }*/

  .modal-content {
    /*height: 485px;*/
  }
  .modal-title {
    text-align: center;
  }
  .modal-body {
    text-align: center;
    /*height: 355px;*/
    overflow: auto;
  }
  .modal-footer {
    text-align: center;
  }
  .homeworkArrange_form input,.homeworkArrange_form select {
    width: 100%;
    height: 32px;
    margin: 10px 0;
  }
  .btn_save, .btn_cancel{
    width:15%;
    height: 40px;
  }
  textarea {
    width: 100%;
    height: 100px;
    resize:none;
    margin: 0 0 0 0;
  }
  /*.attachment_pic {
    background-image: url("../img/right/homeworkArrange/attachment_pic.png");
  }*/
  .attachment_div {
    float: left;
    margin: 20px 0 0 10px;
  }
  /*.attachment_pic,attachment_add{
    float: left;
  }
  .attachment_link{
    float: right;
  }*/
  .homework_type_add {
    width: 160px;
    height: 50px;
    margin: 0 0 0 12px;
  }
  .homework_type_add input {
    width: 150px;
    height: 32px;
  }
  .homework_type_add button {
    width: 60px;
    border-radius: 5px;
    margin: 10px 0 0 0;
  }

  .btn.upload_sp {
    width:100px;
    height: 100px;
    border: 1px dashed #000000;
  }
  .btn.upload_sp:hover {
    background-color: lightgrey;
  }
  .btn.upload_resource {
    width: 100px;
    height: 32px;
    border: 1px dashed #000000;
    margin: 22px 0 0 0;
  }
  .btn.upload_resource:hover{
    background-color: lightgrey;
  }


  .displayVideoUploadCom {
    display: none;
  }
  .editVideoDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .editVideoDiv span {
    float: right;
  }

  .fileListP {
    margin: 0 0 10px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
  .fileListP a {
    color: black;
  }
  input.form-control {
    display: inline-block;
    width: 97%;
  }
  textarea.form-control {
    display: inline-block;
    width: 97%;
  }
  span.spanRed.homeSummary {
    position: absolute;
    top: 17%;
    right:2.5%;
  }
  textarea.form-control.homeSummary {
    margin: 0 15px 0 0;
  }

  .previewImg {
    max-width: 100%;
  }
  .modal-body_preview {
    text-align: center;
  }
  .modal-dialog_preview {
    width: 60%;
  }

  .nav-tabs {
    border-bottom: 0px solid #ddd;
  }

</style>



// WEBPACK FOOTER //
// src/components/homeworkArrange.vue